import {useRouter} from 'next/router';
import {ProviderTypeEnum} from 'types';

import {useIsomorphicLayoutEffect} from './useIsomorphicLayoutEffect';

export function useHomePageLoad() {
  const {push, query} = useRouter();
  /**
   * Filter Handle
   */
  // https://github.com/react-component/overflow/issues/6
  useIsomorphicLayoutEffect(() => {
    if (query.filter) {
      if (query.filter === 'all') {
        //FOR SEO REDIRECT ON RESTAURANT
        push(`/?providerType=${ProviderTypeEnum.RESTAURANT}`);
      } else if (query.filter === 'markets') {
        //FOR SEO REDIRECT ON MARKET
        push(`/?providerType=${ProviderTypeEnum.MARKET}`);
      } else if (query.filter === 'promo') {
        //FOR SEO REDIRECT ON FILTERS
        push(`/restaurants?filters=${query.filter}&promo_type=${query.filter}&ordering=default`);
      } else {
        push(`/restaurants?filters=${query.filter}&ordering=default`);
      }
    }
  }, [query, push]);
}
